import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NavParams} from '@ionic/angular';
import {Router} from '@angular/router';
import { TooltipsService } from '@core/state/tooltips';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
})
export class DefaultHeaderComponent implements OnInit {
  @Input('title') title = 'Title';
  /**
   * Use back button instead of menu
   */
  @Input('back') back = false;
  @Input('defaultHref') defaultHref = '/dashboard/people';
  @Input('editLink') editLink = null;

  constructor(
    private route: Router,
    private tooltipsService: TooltipsService
  ) { }

  ngOnInit() {};

  edit() {
    this.route.navigateByUrl(this.editLink);
  }

  invalidateCache() {
    this.tooltipsService.invalidateCache().subscribe();
  }
}
